// Types and label maps shared by the backend and the frontend.
export const ROLES = ['admin', 'manager', 'viewer'];
export const ROLE_LABELS = {
    admin: 'Admin',
    manager: 'Manager',
    viewer: 'Viewer',
};
export const ROLE_DESCRIPTIONS = {
    admin: 'Full control: manage users, connections, knowledge sources and approvals.',
    manager: 'Run scans/ingest, ask the agent and approve drafts. No user management.',
    viewer: 'Read-only: view the dashboard, knowledge base and drafts.',
};
export const PERMISSIONS = [
    'manage_users',
    'manage_connections',
    'run_ingest',
    'approve_drafts',
    'ask',
    'view',
];
export const PERMISSION_LABELS = {
    manage_users: 'Manage users',
    manage_connections: 'Manage connections',
    run_ingest: 'Run scans & ingest',
    approve_drafts: 'Approve drafts',
    ask: 'Ask the agent',
    view: 'View dashboard',
};
export const ROLE_PERMISSIONS = {
    admin: ['manage_users', 'manage_connections', 'run_ingest', 'approve_drafts', 'ask', 'view'],
    manager: ['manage_connections', 'run_ingest', 'approve_drafts', 'ask', 'view'],
    viewer: ['view'],
};
export function isRole(v) {
    return v === 'admin' || v === 'manager' || v === 'viewer';
}
export function permissionsForRole(role) {
    return ROLE_PERMISSIONS[role] ?? [];
}
export function hasPermission(role, perm) {
    return permissionsForRole(role).includes(perm);
}
export const AUDIENCE_LABELS = {
    customer: 'Customer',
    installer: 'Installer',
    sales: 'Sales rep',
};
export const CHANNEL_LABELS = {
    chat: 'Chat',
    text: 'Text',
    email: 'Email',
};
// [label, css-class] — mirrors the reference page's OUT map.
export const OUTCOME_LABELS = {
    answer: ['Answer', 's-answer'],
    handover: ['Handed to team', 's-handover'],
    decline: ['Declined', 's-decline'],
    clarify: ['Needs more info', 's-clarify'],
};
export const AUDIENCES = ['customer', 'installer', 'sales'];
export const CHANNELS = ['chat', 'text', 'email'];
export const AUTOMATED_RESPONSE_PREFIX = 'This is an automated response from TSBA Technical Support.';
export function isOutcome(v) {
    return v === 'answer' || v === 'handover' || v === 'decline' || v === 'clarify';
}
export function isAudience(v) {
    return v === 'customer' || v === 'installer' || v === 'sales';
}
export function isChannel(v) {
    return v === 'chat' || v === 'text' || v === 'email';
}
export const CONNECTION_PROVIDERS = ['google-drive', 'gmail'];
export const CONNECTION_LABELS = {
    'google-drive': 'Google Drive',
    gmail: 'Gmail',
};
/** What each connector is for, shown in the Connections UI. */
export const CONNECTION_PURPOSE = {
    'google-drive': 'Ingest product guides, warranties and data sheets as knowledge sources.',
    gmail: 'Receive and send support email (replies stay approval-gated).',
};
export function isConnectionProvider(v) {
    return v === 'google-drive' || v === 'gmail';
}
export const AGENT_PROFILE = {
    name: 'TSBA Technical Support AI',
    tagline: 'Drafts accurate solar, battery & inverter support answers — for a human to approve.',
    role: 'Technical-support assistant for TSBA installers, customers and sales staff.',
    capabilities: [
        'Answers from TSBA’s own product guides, warranties and data sheets (Google Drive).',
        'Grounds every reply in retrieved knowledge and cites its sources.',
        'Adapts tone and detail to the audience: customer, installer or sales.',
        'Applies AS/NZS 5139 battery-install rules and Safe Work electrical code.',
        'Hands complex or unsafe cases to the human team instead of guessing.',
    ],
    guardrails: [
        'Every reply is a draft — nothing is sent without human approval.',
        'Never quotes or invents pricing.',
        'Only states what the connected knowledge base supports.',
        'OAuth tokens are encrypted at rest and never leave the server.',
    ],
};
// ─── Google Drive: browse & ingest ───────────────────────────────────────────
export const DRIVE_FOLDER_MIME = 'application/vnd.google-apps.folder';
//# sourceMappingURL=index.js.map